module.exports = {
      id: "google-play-usage",
      viewBox: "0 0 180 53.33",
      url: __webpack_public_path__ + "svg-sprite-f952e3bcb1151291994742cd359b350c.svg#google-play",
      toString: function () {
        return this.url;
      }
    }